import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ItemCategory from 'components/Header/NavBar/ItemCategory';
import TagManagerService from "services/TagManager";
import BannerHour from 'components/Header/BannerHour';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss'; //NOSONAR

const NavBar = (props) => {
    const menuContainer = useRef(null);
    const isMobile = useViewportMediaQuery(1121)

    const getContainerRef = () => {
        return menuContainer.current;
    };

    if (isMobile) return '';

    return (
        <div className="new-header-nav-bar">
            <nav className="new-header-nav-bar-wrapper" ref={menuContainer}>
                <BannerHour id={1} />
                <Link to={"/oferta/ofertas-fdm?nombre_promo=boton-ofertas-home08072019"} className="new-header-nav-bar-offers-btn" onClick={() => TagManagerService.menu('Ofertas', 'Ofertas', 'Menú Superior')}>  Ofertas</Link>
                <div className="new-header-nav-bar-categories">
                    <ItemCategory title="Supermercado" categories={props.categories} getContainerRef={getContainerRef} />
                    {props.fixedCategories && props.fixedCategories.map((item) => {
                        return (
                            <ItemCategory title={item.title} url={item.url} categories={item.items || []} key={item.title} getContainerRef={getContainerRef} />
                        )
                    })}
                </div>
            </nav>
        </div>
    )
}

NavBar.propTypes = {
    categories: PropTypes.array,
    fixedCategories: PropTypes.array
};

export default NavBar;
